import CommomProxy from '@/components/proxy/CommomProxy'

let child_routes = [{
    path: 'index',
    name: 'index',
    component: resolve => {
        require(['@/views/share/index.vue'], resolve);
    },
    meta: {
        title: '分享得红包'
    }
}]

let route = [{
    path: '/share',
    component: CommomProxy,
    children: child_routes
}]

export default route


// WEBPACK FOOTER //
// ./src/router/share.js